import { render, staticRenderFns } from "./AccountTabUsers.vue?vue&type=template&id=00b8b868&scoped=true"
import script from "./AccountTabUsers.vue?vue&type=script&lang=js"
export * from "./AccountTabUsers.vue?vue&type=script&lang=js"
import style0 from "./AccountTabUsers.vue?vue&type=style&index=0&id=00b8b868&prod&lang=scss"
import style1 from "./AccountTabUsers.vue?vue&type=style&index=1&id=00b8b868&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8b868",
  null
  
)

export default component.exports